import * as React from "react";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import {NumericFormat} from "react-number-format";
import {muiGridLocales} from "../../../../helpers/mui/muiLocales";
import {CustomPagination} from "../../../../components/mui/grids/dataGridCustom/customPagination";
import {DataGridPremium} from "@mui/x-data-grid-premium";
import {GridToolbar, initialFilters, mapFilters} from "../../pages/index";
import {useTranslation} from "react-i18next";
import {ISSUES_GLOBAL} from "../../locales/namespaces";
import useUserData from "../../../../hooks/user/useUserData";
import {useEffect, useMemo, useState} from "react";
import TruncateDescription from "../../../../pages/dashboard/partials/truncateDescription";
import CardChip from "../../../../pages/dashboard/partials/cardChip";
import {numericFormatDigitDefaults} from "../../../../helpers/theme/defaultProps";
import {withPermissionHOC} from "../../../permission/components/permissionHOC/permissionHOC";
import {view_po} from "../../../../helpers/rights/rights";
import axios from "axios";
import {API} from "../../../../helpers/constants";
import _ from "lodash";
import {enqueueSnackbar} from "notistack";
import {handleAxiosErrors, logoutUnauthorizedUser} from "../../../../helpers/errorHandling";
import {LoadingButton} from "@mui/lab";
import TextField from "@mui/material/TextField";

const PO = ({
                open,
                onClose,
                data,
                rowSelectionModel,
                dataManager,
                setLastSearchFilters,
                setRowSelectionModel,
                setFilters,
                initialFilters,
                filters,
    loadingIndex
}) => {
    const { t } = useTranslation(ISSUES_GLOBAL)
    const {language,decimalSeparator, thousandSeparator,token } = useUserData()
    const [loading,setLoading] = useState(false)
    const [loadingStore,setLoadingStore] = useState(false)
    const [poDescription,setPoDescription] = useState('')
    const [rows, setRows] = useState([]);

    useEffect(() => {
        const mappedRows = (data || []).map((row) => ({
            ...row,
            EditableChargeCost:
                row.EditableChargeCost != null
                    ? Number(row.EditableChargeCost)
                    : Number(row.ChargeCost) || 0,
        }));

        setRows(mappedRows);
    }, [data]);

    const totalChargeCost = React.useMemo(() => {
        return (rows || []).reduce((sum, row) => {
            return sum + (Number(row.ChargeCost) || 0);
        }, 0);
    }, [rows]);

    const totalEditableChargeCost = React.useMemo(() => {
        return (rows || []).reduce((sum, row) => {
            return sum + (Number(row.EditableChargeCost) || 0);
        }, 0);
    }, [rows]);

    const totalRow = useMemo(() => ({
        Code: t("Total"),
        Description: "",
        CustName: "",
        Address: "",
        ChargeCost: totalChargeCost,
        EditableChargeCost: totalEditableChargeCost,
    }), [totalChargeCost, totalEditableChargeCost, t]);

    const columns = useMemo(() => [
        {
            field: 'Code',
            headerName: t('Code'),
            description: t('Code'),
            minWidth: 100,
            flex: 1,
            renderCell: (params) => {
                const isTotal = params.value === t("Total");
                return (
                    <Typography fontWeight={isTotal ? 700 : 400}>
                        {params.value}
                    </Typography>
                );
            }
        },
        {
            field: 'Description',
            headerName: t('Description'),
            description: t('Description'),
            minWidth: 200,
            flex: 1,
            renderCell: (params) => {
                return <TruncateDescription value={params.value}/>
            },
        },
        {
            field: 'CustName',
            headerName: t('Customer'),
            description: t('Customer'),
            minWidth: 250,
            flex: 1,
            renderCell: (params) => {
                return <TruncateDescription value={params.value}/>
            },
        },
        {
            field: 'Address',
            headerName: t('Site'),
            description: t('Site'),
            minWidth: 250,
            flex: 1,
            renderCell: (params) => {
                return <TruncateDescription value={params.value}/>
            },
        },
        {
            field: 'ChargeCost',
            headerName: t('Subcontractor Charge'),
            description: t('Subcontractor Charge'),
            minWidth: 100,
            type: 'number',
            flex: 1,
            valueGetter: (value, row, column, apiRef) => value ? Number(value) : 0,
            renderCell: (params) => {
                const isTotal = params.row.Code === t("Total");

                return (
                    <NumericFormat
                        {...numericFormatDigitDefaults}
                        thousandSeparator={thousandSeparator}
                        decimalSeparator={decimalSeparator}
                        displayType="text"
                        value={params.value}
                        style={{ fontWeight: isTotal ? 700 : 400 }}
                    />
                );
            }

        },
        {
            field: 'EditableChargeCost',
            headerName: t('Editable Charge'),
            description: t('Editable Charge'),
            minWidth: 140,
            type: 'number',
            flex: 1,
            editable: true,
            valueGetter: (value) => value ? Number(value) : 0,
            valueParser: (value) => {
                if (value == null || value === '') return 0;
                return Number(String(value).replace(',', '.')) || 0;
            },
            renderCell: (params) => {
                const isTotal = params.row.Code === t("Total");

                return (
                    <NumericFormat
                        {...numericFormatDigitDefaults}
                        thousandSeparator={thousandSeparator}
                        decimalSeparator={decimalSeparator}
                        displayType="text"
                        value={params.value}
                        style={{ fontWeight: isTotal ? 700 : 400 }}
                    />
                );
            }
        }

    ], [t])

    const handleCreatePO = () => {
        const chargesArray = rows.map((row) => ({
            id: row.id,
            value: row.EditableChargeCost,
        }));

        setLoading(true)
        axios({
            method: 'post',
            data: {
                SupplierId:data[0].AssigneeId,
                //issues: rowSelectionModel,
                issues: chargesArray,
                Description:poDescription,
                isSaved:0
            },
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
            url: `${API}/en/custom/purchase/workOrder/store`
        }).then((res) => {
            const onSuccess = () => {
                //setLastSearchFilters(null);
                setRowSelectionModel([]);
                setPoDescription('')
                //setFilters(initialFilters)
                onClose()

                enqueueSnackbar(t('P.O created successfully!'), {
                    variant: 'success',
                    autoHideDuration: 3000,
                })
                setLoading(false)
            }
            const params =  { ...mapFilters(filters) };
            dataManager(params, onSuccess)
        }).catch((error) => {
            setLoading(false)
            enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
                variant: 'error',
                autoHideDuration: 3000,
            })

        })
    }

    const handleCreatePOStore = () => {
        const chargesArray = rows.map((row) => ({
            id: row.id,
            value: row.EditableChargeCost,
        }));

        setLoadingStore(true)
        axios({
            method: 'post',
            data: {
                SupplierId:data[0].AssigneeId,
                //issues: rowSelectionModel,
                issues: chargesArray,
                Description:poDescription,
                isSaved:1
            },
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
            url: `${API}/en/custom/purchase/workOrder/store`
        }).then((res) => {
            const onSuccess = () => {
                //setLastSearchFilters(null);
                setRowSelectionModel([]);
                setPoDescription('')
                //setFilters(initialFilters)
                onClose()

                enqueueSnackbar(t('P.O created successfully!'), {
                    variant: 'success',
                    autoHideDuration: 3000,
                })
                setLoadingStore(false)
            }
            const params =  { ...mapFilters(filters) };
            dataManager(params, onSuccess)
        }).catch((error) => {
            setLoadingStore(false)
            enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
                variant: 'error',
                autoHideDuration: 3000,
            })

        })
    }
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
        >
            <DialogTitle>
                {t('Create P.O')}
            </DialogTitle>

            <Divider />

            <DialogContent sx={{ mt: 2 }}>
                {(!data || data.length === 0) ? (
                    <Typography color="text.secondary">
                        {t('No selected tickets')}
                    </Typography>
                ) : (
                    <>
                        <Typography sx={{ mb: 2 }}>
                             <strong> {data[0].Assignee} </strong>
                        </Typography>
                        <Box sx={{mt:1,mb:2, width:'40%'}}>
                            <TextField
                                label={t("Description")}
                                name="poDescription"
                                value={poDescription}
                                onChange={(e) => setPoDescription(e.target.value.slice(0, 200))}
                                inputProps={{ maxLength: 200 }}
                                helperText={`${poDescription.length}/200`}
                                multiline
                                minRows={2}
                                fullWidth
                                variant="outlined"
                                // InputLabelProps={{
                                //     shrink: true,
                                // }}
                                placeholder={t("Enter P.O description")}
                                sx={{
                                    "& .MuiInputLabel-root": {
                                        color: "#004B88",
                                        fontWeight: 500,
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        alignItems: "flex-start",
                                        backgroundColor: "#fff",
                                        "& fieldset": {
                                            borderColor: "#004B88",
                                        },
                                        "&:hover fieldset": {
                                            borderColor: "#004B88",
                                        },
                                        "&.Mui-focused fieldset": {
                                            borderColor: "#004B88",
                                            borderWidth: 2,
                                        },
                                    },
                                    "& .MuiOutlinedInput-input": {
                                        paddingTop: "10px",
                                    },
                                }}
                            />


                        </Box>

                        <Box>
                            <DataGridPremium
                                rows={rows}
                                columns={columns}
                                getRowId={(row)=>row.Code}
                                pinnedRows={{
                                    bottom: [totalRow],
                                }}
                                processRowUpdate={(newRow) => {
                                    const updatedRow = {
                                        ...newRow,
                                        EditableChargeCost: Number(newRow.EditableChargeCost) || 0,
                                    };

                                    setRows((prev) =>
                                        prev.map((row) => (row.Code === updatedRow.Code ? updatedRow : row))
                                    );

                                    return updatedRow;
                                }}
                                hideFooterPagination
                                hideFooterSelectedRowCount
                                initialState={{
                                    density: 'compact'
                                }}
                                slots={{
                                    //pagination: CustomPagination,
                                }}
                                slotProps={{
                                    toolbar: {
                                        t: t,
                                    }
                                }}
                                disableSelectionOnClick
                                localeText={muiGridLocales(language)}
                            />
                        </Box>
                    </>
                )}
            </DialogContent>

            <DialogActions  sx={{display:'flex',justifyContent:'space-between'}}>
                <Box sx={{display:'flex',gap:2}}>
                    <LoadingButton
                        loading={loadingIndex || loading || loadingStore}
                        variant="contained"
                        color="warning"
                        disabled={!data || data.length === 0}
                        onClick={() => handleCreatePO()}
                    >
                        {t('Create P.O')}
                    </LoadingButton>
                    <LoadingButton
                        loading={loadingIndex || loading || loadingStore}
                        variant="contained"
                        color="warning"
                        disabled={!data || data.length === 0}
                        onClick={() => handleCreatePOStore()}
                    >
                        {t('Store and save')}
                    </LoadingButton>
                </Box>
                <LoadingButton
                    loading={loadingIndex || loading || loadingStore}
                    disabled={!data || data.length === 0}
                    onClick={()=>{
                        onClose()
                        setPoDescription('')
                    }}
                    variant="outlined"
                    color={'error'}
                >
                    {t('Cancel')}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};

export default withPermissionHOC(PO,[view_po]);
